// javascript
import { config } from "/app.config"

// Feature flags (toggle per condition)
const FEATURE_FLAGS = {
  streaming: true,
  live: true,
  podcasts: true,
  podcastsOverview: true,
  podcastsFull: true,
  raw: true,
  ctl: config.isZeno,
  app: config.isZeno,
  soundExchangeReports: config.isSurferNetwork || config.isZeno,
}

// Build Podcasts children conditionally
const podcastsChildren = [
  FEATURE_FLAGS.podcastsOverview && {
    name: "analytics.podcasts.overview",
    path: "overview",
    component: () => import("@/views/Analytics/AnalyticsPodcastsOverview"),
    meta: {
      pageTitle: "Podcasts analytics overview",
      parent: "analytics.podcasts",
      icon: "MicIcon",
      rule: "owner",
    },
  },
  FEATURE_FLAGS.podcastsFull && {
    name: "analytics.podcasts.full",
    path: "full",
    component: () => import("@/views/Analytics/AnalyticsPodcastsFull"),
    meta: {
      pageTitle: "Podcasts analytics",
      parent: "analytics.podcasts",
      icon: "MicIcon",
      rule: "owner",
    },
  },
].filter(Boolean)

// Build Analytics children conditionally
const analyticsChildren = [
  FEATURE_FLAGS.streaming && {
    name: "analytics.streaming",
    path: "streaming",
    component: () => import("@/views/Analytics/AnalyticsStreaming"),
    meta: {
      pageTitle: "Streaming analytics",
      parent: "analytics",
      icon: "PhoneIncomingIcon",
      rule: "owner",
    },
  },
  FEATURE_FLAGS.live && {
    name: "analytics.live",
    path: "live",
    component: () => import("@/views/Analytics/AnalyticsLive"),
    meta: {
      pageTitle: "Live analytics",
      parent: "analytics",
      icon: "ActivityIcon",
      rule: "owner",
    },
  },
  FEATURE_FLAGS.podcasts && {
    name: "analytics.podcasts",
    path: "podcasts",
    component: () => import("@/views/Analytics/AnalyticsPodcasts"),
    meta: {
      pageTitle: "Podcasts analytics",
      parent: "analytics",
      icon: "MicIcon",
      rule: "owner",
    },
    children: podcastsChildren,
  },
  FEATURE_FLAGS.raw && {
    name: "analytics.raw",
    path: "raw",
    component: () => import("@/views/Analytics/AnalyticsRaw"),
    meta: {
      pageTitle: "Podcasts raw",
      parent: "analytics",
      icon: "BarChartIcon",
      rule: "owner",
    },
  },
  FEATURE_FLAGS.ctl && {
    name: "analytics.ctl",
    path: "ctl",
    component: () => import("@/views/Analytics/AnalyticsCTL"),
    meta: {
      pageTitle: "Call-in analytics",
      parent: "analytics",
      icon: "PhoneIncomingIcon",
      rule: "owner",
    },
  },
  FEATURE_FLAGS.app && {
    name: "analytics.app",
    path: "app",
    component: () => import("@/views/Analytics/AnalyticsApp"),
    meta: {
      pageTitle: "App analytics",
      parent: "analytics",
      icon: "PhoneIncomingIcon",
      rule: "owner",
    },
  },
  FEATURE_FLAGS.soundExchangeReports && {
    name: "analytics.soundExchangeReports",
    path: "sound-exchange-reports",
    component: () => import("@/views/Analytics/AnalyticsSoundExchangeReports"),
    meta: {
      pageTitle: "Sound Exchange Reports",
      parent: "analytics",
      icon: "PhoneIncomingIcon",
      rule: "owner",
    },
  },
].filter(Boolean)

const router = [
  {
    path: "analytics",
    name: "analytics",
    component: () => import("@/views/Analytics/Analytics"),
    meta: {
      pageTitle: "Account analytics",
      icon: "BarChart2Icon",
      rule: "owner",
    },
    children: analyticsChildren,
  },
]

export default router
